import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  ControlContainer,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { SystemService } from 'common/services/core-services/system.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmBtnMetaModel } from 'common/models/utility-models/meta-model';

@Component({
  selector: 'sm-sub-form',
  templateUrl: './sm-sub-form.component.html',
  styleUrls: ['./sm-sub-form.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmSubFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: SmSubFormComponent,
      multi: true,
    },
  ],
})
export class SmSubFormComponent
  extends SmUiComponent
  implements OnInit, AfterViewChecked, OnChanges {
  @ViewChild('deleteFile', { static: false }) deleteFile: ElementRef;

  @Output() fileDeleted = new EventEmitter<any>();
  @Output() smdynamic = new EventEmitter<any>();
  @Output() tabSwitch = new EventEmitter<any>();
  @Output() emitFields = new EventEmitter<any>();
  @Output() emitSelectFields = new EventEmitter<any>();
  todeleteFileDetails: any;
  newAttribute: any = {};
  @Output() initInput = new EventEmitter<any>();
  fieldArray: Array<any> = [];
  formFields: Array<any> = [];
  @Input() propMeta;
  @Input() propData;
  @Input() Form;
  @Input() EditModel: any = null;
  public GroupForm: FormGroup;
  responseArray: any = [];
  DynamicForm: any = new FormGroup({});
  count: number = 1;
  presentDynamicField: any = null;
  toggleSwitch: number = 0;
  todeleterow: any;
  pageNum: any = 1;
  page = {
    pageSize: 5,
    pageNumber: 1,
    maxSize: 5,
  };

  @ViewChild('statuscontent', { static: false }) statuscontent: ElementRef;

  statusBtnProps = new SmBtnMetaModel('Yes', 'grey', false, true, true);
  statusNoBtnProps = new SmBtnMetaModel('No', 'light', false, true, true);
  new_fields: any[] = [];
  constructor(
    private fb: FormBuilder,
    private readonly changeDetectorRef: ChangeDetectorRef,
    protected toastr: ToastrService,
    private modalService: NgbModal,

    protected override injector: Injector,
    protected ss: SystemService
  ) {
    super(injector);

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['EditModel']) {
      this.changeDetectorRef.detectChanges();
    }
  }


  initInputAction(event, field) {
    if (event) {
      this.initInput.emit(field);
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.formcontrol.setErrors(null);
    this.initDynamicForm();
    this.paginatedFields();

  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  initDynamicForm() {
    this.Form.addControl(this.props.field_Name, new FormControl(null));
    Object.keys(this.props.fields).forEach((field) => {
      this.formFields.push(this.props.fields[field]);
    });

    if (this.EditModel === undefined ? false : this.EditModel.length > 0) {
      this.setPatchedValues();
      this.responseArray = JSON.parse(JSON.stringify(this.EditModel));
    } else {
      this.fieldArray.push(this.generateForm(this.props.fields));

    }
    this.emitFields.emit({ response: this.responseArray, form: this.fieldArray })
  }

  setPatchedValues() {
    const formlength = this.EditModel.length;

    for (let index = 0; index < formlength; index++) {
      // const element = array[index];
      const newForm = this.generateForm(
        this.props.fields,
        this.EditModel[index]
      );
      newForm.clearValidators();
      newForm.updateValueAndValidity();
      this.fieldArray.push(newForm);
    }
  }



  addFieldValue() {

    if (this.areFormsValid()) {
      this.newAttribute = {};
      this.DynamicForm = new FormGroup({});
      const fieldValues = this.fieldArray.map((formGroup) => formGroup.value);
      this.smdynamic.emit(fieldValues);
      if (this.fieldArray.length < this.props.maxrows) {
        const newForm = this.generateForm(this.props.fields);
        if (this.props.formtype === 'addfirst') {
          const insertIndex = (this.page.pageNumber - 1) * this.page.pageSize;
          this.fieldArray.splice(insertIndex, 0, newForm);
          const newModel = {};
          for (const key in this.EditModel[0]) {
            newModel[key] = '';
          }

          this.EditModel.splice(insertIndex, 0, newModel);
          this.paginatedFields();
        } else {
          this.fieldArray.push(newForm);


        }
        // this.emitFeilds.emit(this.fieldArray)
      } else {
        this.toastr.info('Maximum limit reached');
      }
    } else {
      this.ss.showError('Please fill in the previous fields to add a new one');
    }
  }

  bindFormControlsToModel(form: FormGroup, model: any) {
    for (const key in form.controls) {
      if (form.controls.hasOwnProperty(key)) {
        form.controls[key].valueChanges.subscribe((value) => {
          model[key] = value;
        });
      }
    }
  }

  onPageChange(event: any) {
    this.page.pageNumber = event.page;
    this.paginatedFields();
  }

  paginatedFields() {
    const startIndex = (this.page.pageNumber - 1) * this.page.pageSize;
    const endIndex = startIndex + this.page.pageSize;
    this.new_fields = this.fieldArray.slice(startIndex, endIndex);
  }

  deleteFieldValue(index, form) {
    if (this.presentDynamicField !== null) {
      const value = form.value[this.presentDynamicField.field_Name];
      this.presentDynamicField.originalOptions.forEach((element) => {
        if (element.id === value) {
          this.presentDynamicField.options.push(element);
        }
      });
    }
    this.fieldArray.splice(index, 1);
    if (this.EditModel !== null) {
      this.Form.value[this.props.field_Name].splice(index, 1);
      this.Form.controls[this.props.field_Name].setErrors(null);
    }
  }

  generateForm(formData, patchedValue: any = null): any {
    const keyData = Object.keys(formData);
    let form;
    form = new FormGroup({});
    keyData.forEach((element: any) => {
      this.addFormControl(element, form);
    });
    if (patchedValue !== null) {
      this.patchValues(form, patchedValue);
      this.validate(form);
    } else {
      this.patchValues(form, null);
      if (!this.props.isExtraValidation) {
        this.validate(form);
      }
      // this.EditModel.unshift({
      //   achievementId: '',
      //   title: '',
      //   fileName: '',
      //   fileOriginalName: '',
      //   filePath: '',
      // });
      //this.isNewFormAdded=true;
    }
    return form;
  }

  addFormControl(element, form): void {
    if (this.props.fields[element] !== undefined) {
      form.addControl(element, new FormControl(null));
    } else {
    }
  }

  // areFormsValid(): boolean {

  //   for (let form of this.fieldArray) {
  //     console.log(form ,"hello form  ")

  //     if (form.invalid) {
  //       form.options==
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  areFormsValid(): boolean {

    for (let form of this.fieldArray) {


      if (form.invalid) {
        return false;
      }
    }

    return true;
  }

  patchValues(form, patchedValue: any = null): void {
    const keys = Object.keys(this.props.fields).filter((key: any) => {
      if (key !== 'id') {
        return true;
      } else if (!this.props.extraNullFields.includes(key)) {
        return true;
      } else if (key === 'fundCode') {
        return false;
      } else {
        return false;
      }
    });
    keys.forEach((field: any) => {
      if (this.props.fields[field] !== undefined) {
        if (this.props.fields[field]['isFormControl'] === true) {
          if (patchedValue !== null) {
            form.patchValue({
              [field]: patchedValue[field],
            });
          } else {
            form.patchValue({
              [field]: this.props.fields[field.field_Name],
            });
            if (this.props.fields[field].proptype === 'checkbox') {
              form.patchValue({
                [field]: false,
              });
            }
          }
        }
      }
    });
  }

  setValue(form, event, index, field = null, fieldType = null): void {
    this.Form.controls[this.props.field_Name].setValidators(null);
    // if (
    //   field !== null &&
    //   field.hasOwnProperty('options') &&
    //   field.fieldType === 'select'
    // ) {
    //   this.presentDynamicField = field;
    //   field.options = field.options.filter(
    //     (element) => element.id !== event.id
    //   );
    // }
    const values = form.value;
    const objectValues = Object.values(values);
    // To validate Invalid Priority
    // if (field === 'input' && fieldType === 'priority') {
    //   this.responseArray.forEach((element) => {
    //     if (parseInt(element['priority']) === parseInt(event.target.value)) {
    //       this.toastr.error('Data with same priority already exists');
    //       form.controls['priority'].setValue(null);
    //     }
    //   });
    // }
    if (this.EditModel?.length === 0 || this.EditModel === null) {
      if (!objectValues?.includes(null) && !objectValues?.includes(undefined)) {
        let add;
        const responseData = {
          id: this.fieldArray.length,
        };
        Object.keys(form.value).forEach((key) => {
          responseData[key] = form.value[key];
        });
        if (Object.keys(this.props.propextraNullFields).length > 0) {
          Object.keys(this.props.extraNullFields).forEach((element) => {
            responseData[element] = this.props.extraNullFields[element];
          });
        }
        if (this.responseArray.length > 0) {
          this.responseArray.filter((element) => {
            if (element['id'] === index + 1) {
              add = 1;
            }
          });
        }
        if (add === 1) {
          this.responseArray[index] = responseData;
        } else {
          this.responseArray.push(responseData);
        }
        this.count++;
      }
      let finalArray = JSON.parse(JSON.stringify(this.responseArray));
      finalArray.forEach((item) => {
        item.id = null;
      });

      this.Form.patchValue({
        [this.props.field_Name]: finalArray,
      });
      if (fieldType === 'dynamicform') {
        this.patchDynamicFormValue(event, field);
      }
    } else {
      const valueKeys = Object.keys(form.value);
      if (this.responseArray[index] !== undefined) {
        valueKeys.forEach((key) => {
          if (form.value[key] !== undefined) {
            this.responseArray[index][key] = form.value[key];
          }
        });
      } else {
        const responseData = values;
        responseData['id'] = null;
        if (Object.keys(this.props.propextraNullFields).length > 0) {

          Object.keys(this.props.extraNullFields).forEach((element) => {
            responseData[element] = this.props.extraNullFields[element];
          });
        }
        this.responseArray.push(responseData);
      }
      this.emitFields.emit({ form: this.fieldArray, response: this.responseArray })

      // this.emitSelectFields.emit(this.responseArray)


      this.Form.patchValue({
        [this.props.field_Name]: this.responseArray,
      });
    }
  }

  patchDynamicFormValue(event, index, field = null): void {
    this.Form.patchValue({
      [field.field_Name]: event,
    });
  }

  deleteFilePopup(event: any) {
    this.todeleteFileDetails = event;
    this.modalService.open(this.deleteFile, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'md',
    });
  }

  deleteUploadedFile() {
    this.fileDeleted.emit(this.todeleteFileDetails);
    this.modalService.dismissAll();
  }


  evaluate(field, index, form) {
    if (field.hasOwnProperty('condition')) {
      const condition = field.propcondition;
      if (condition.evalParam.length > 0) {
        return condition.evalParam.includes(form.value[condition.evalKey]);
      } else {
        return true;
      }
    } else {
      return true;
    }
  }


  openConfirmationStatusPopup(row?: any) {
    this.todeleterow = row;
    this.modalService.open(this.statuscontent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'md'
    });
  }

  pageChanged(event): void {
    this.pageNum = event.page;
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = this.propData.pageModel.length;
    this.propData.filterModel = this.propData.pageModel.slice(startItem, endItem);
  }

  StatusGridRow() {
    this.tabSwitch.emit({
      row: this.todeleterow,
      condition: this.propMeta.properties.isStatusFilter
    });
    this.modalService.dismissAll();
    this.pageChanged({ page: 1, itemsPerPage: 8 });
    this.toggleSwitch = 0;
  }

  override validate(control: AbstractControl): ValidationErrors | null {
    this.formcontrol = control;
    if (!this.props.required) {
    //  console.log('inside validator', this.props, this.Form)
      this.formcontrol.setValidators(null);
      this.formcontrol.setErrors(null);
      this.formcontrol.updateValueAndValidity();

    }
    return control;
  }
}
